// booksActions.js

const ADD = 'bookstore/books/ADD';
const UPDATE = 'bookstore/books/UPDATE';
const REMOVE = 'bookstore/books/REMOVE';
const GET = 'bookstore/books/GET';
const ASYNC_ADD = 'bookstore/books/ASYNC_ADD';
const ASYNC_REMOVE = 'bookstore/books/ASYNC_REMOVE';

export {
  ADD,
  UPDATE,
  REMOVE,
  GET,
  ASYNC_ADD,
  ASYNC_REMOVE,
};
